/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type NewsListingUmbPageContentModelContentType =
	(typeof NewsListingUmbPageContentModelContentType)[keyof typeof NewsListingUmbPageContentModelContentType];

export const NewsListingUmbPageContentModelContentType = {
	newsListingUmbPage: "newsListingUmbPage",
} as const;
